export enum TableName {
    UserDetails = "UserDetails",
    AuthorisationRequests = "AuthorisationRequests",
    AuthorisationStatus = "AuthorisationStatus",
    AuthorisationTokens = "AuthorisationTokens",
    Approvers = "Approvers"
}
